var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-manager-copy-selector"
    },
    [
      _vm.sourceEmpty
        ? _c(
            "div",
            {
              staticClass: "cw-manager-copy-selector-source"
            },
            [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function click($event) {
                      _vm.selectSource("own")

                      _vm.loadOwnCourseware()
                    }
                  }
                },
                [
                  _c("translate", [
                    _vm._v("Aus persönlichen Lernmaterialien kopieren")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function click($event) {
                      return _vm.selectSource("remote")
                    }
                  }
                },
                [_c("translate", [_vm._v("Aus Veranstaltung kopieren")])],
                1
              )
            ]
          )
        : _c(
            "div",
            [
              _vm.copyAllInProgress
                ? _c("courseware-companion-box", {
                    attrs: {
                      msgCompanion: _vm.copyAllInProgressText,
                      mood: "pointing"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: _vm.reset
                  }
                },
                [_c("translate", [_vm._v("Quelle auswählen")])],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.sourceOwn && _vm.hasRemoteCid,
                      expression: "!sourceOwn && hasRemoteCid"
                    }
                  ],
                  staticClass: "button",
                  on: {
                    click: _vm.selectNewCourse
                  }
                },
                [_c("translate", [_vm._v("Veranstaltung auswählen")])],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.sourceOwn && _vm.hasRemoteCid,
                      expression: "!sourceOwn && hasRemoteCid"
                    }
                  ],
                  staticClass: "button",
                  on: {
                    click: _vm.mergeContent
                  }
                },
                [_c("translate", [_vm._v("Alle Inhalte kopieren")])],
                1
              ),
              _vm._v(" "),
              _vm.sourceRemote
                ? _c(
                    "div",
                    [
                      !_vm.hasRemoteCid
                        ? _c(
                            "h2",
                            [_c("translate", [_vm._v("Veranstaltungen")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hasRemoteCid && _vm.semesterMap.length > 0
                        ? _c(
                            "ul",
                            _vm._l(_vm.semesterMap, function(semester) {
                              return _c(
                                "li",
                                {
                                  key: semester.id
                                },
                                [
                                  _c("h3", [
                                    _vm._v(_vm._s(semester.attributes.title))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    _vm._l(
                                      _vm.coursesBySemester(semester),
                                      function(course) {
                                        return _c(
                                          "li",
                                          {
                                            key: course.id
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "cw-manager-copy-selector-course",
                                                attrs: {
                                                  href: "#"
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.loadRemoteCourseware(
                                                      course.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("studip-icon", {
                                                  attrs: {
                                                    shape: _vm.getCourseIcon(
                                                      course
                                                    )
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      course.attributes.title
                                                    ) +
                                                    "\n                            "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hasRemoteCid && _vm.semesterMap.length === 0
                        ? _c("courseware-companion-box", {
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Es wurden keine Veranstaltung mit Courseware-Inhalten gefunden."
                              ),
                              mood: "sad"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.remoteId !== "" && _vm.hasRemoteCid
                        ? _c("courseware-manager-element", {
                            attrs: {
                              type: "remote",
                              currentElement: _vm.remoteElement
                            },
                            on: {
                              selectElement: _vm.setRemoteId,
                              loadSelf: _vm.loadSelf,
                              reloadElement: _vm.reloadElement
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.remoteId === "" && _vm.hasRemoteCid
                        ? _c("courseware-companion-box", {
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "In dieser Veranstaltung wurden noch keine Inhalte angelegt."
                              ),
                              mood: "sad"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sourceOwn
                ? _c(
                    "div",
                    [
                      _vm.ownId !== ""
                        ? _c("courseware-manager-element", {
                            attrs: {
                              type: "own",
                              currentElement: _vm.ownElement
                            },
                            on: {
                              selectElement: _vm.setOwnId,
                              loadSelf: _vm.loadSelf
                            }
                          })
                        : _c("courseware-companion-box", {
                            attrs: {
                              msgCompanion: _vm.$gettext(
                                "Sie haben noch keine eigenen Inhalte angelegt."
                              ),
                              mood: "sad"
                            }
                          })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }